import { useState } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { logout, getUserInfo } from '../utils/auth';
import { useEscapeToClose } from '../utils/useEscapeToClose';
import Sidebar from '../components/Sidebar';
import PageContextLabel from '../components/PageContextLabel';
import '../components/AnalyticsWorkspace.css';

export default function DashboardPage() {
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // The mobile nav drawer is an overlay too — Escape closes it like the backdrop.
  useEscapeToClose(sidebarOpen, () => setSidebarOpen(false));

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <div className="dashboard-layout">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <button
              className="sidebar-toggle"
              onClick={() => setSidebarOpen((v) => !v)}
              aria-label="Toggle navigation menu"
            >
              {sidebarOpen ? <FiX /> : <FiMenu />}
            </button>
            <h1>Admin Portal</h1>
          </div>
          <div className="user-info">
            <span className="user-name">{userInfo?.name || userInfo?.preferred_username || userInfo?.email || 'Admin'}</span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="dashboard-body">
        <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />
        <div
          className={`sidebar-overlay ${sidebarOpen ? 'show' : ''}`}
          onClick={() => setSidebarOpen(false)}
        />
        <main className="dashboard-main">
          <PageContextLabel />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
